import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Combines multiple class names or class objects into a single string.
 * It uses clsx to merge the class values and then applies Tailwind-specific
 * class merging with twMerge to resolve any conflicts.
 *
 * @param inputs - An array of class values (strings, objects, or arrays)
 * @returns A string of merged and de-duplicated class names
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}